import {Injectable} from '@angular/core';
import {StorageService} from '@services/storage/storage.service';
import {LegendOptions} from 'highcharts';

@Injectable({
  providedIn: 'root'
})
export class ChartLegendSettingsGeneratorService {

  constructor(private storageService: StorageService) {
  }

  public generateLegendSettings(isLineChart: boolean, machineId: string, isInEditMode: boolean, chartId: string | undefined): LegendOptions {
    const self = this;
    const legend: LegendOptions = {
      enabled: true,
      useHTML: true,
      events: {
        itemClick: (event) => {
          this.onLegendSignalNameClick(machineId, isInEditMode, event, isLineChart, chartId);
        }
      },

      itemStyle: {
        fontWeight: 'normal'
      }
    };

    if (isLineChart) {
      legend.symbolPadding = 0;
      legend.symbolWidth = 0;
      legend.symbolHeight = 0;
      legend.squareSymbol = false;
      legend.labelFormatter = function () {
        return self.lineWidgetLegendFormatter(this);
      };
    }
    return legend;

  }

  public onLegendSignalCheckBoxClick(machineId, event) {
    const series = event.target;
    const seriesName = series.name;

    const rangeSeries = this.getRangeSerieByName(seriesName, series.chart.series);
    if (!rangeSeries) {
      return;
    }
    if (event.checked) {
      rangeSeries.show();
    } else {
      rangeSeries.hide();
    }
    const parentSignalName = rangeSeries.userOptions.signalName.replace('_range', '');
    this.setSignalOrRangeVisibility(machineId, parentSignalName, event.checked, false, undefined);
  }

  public onLegendSignalNameClick(machineId, isInEditMode, event, isLineChart: boolean, chartId: string | undefined) {
    event.preventDefault();
    if (isInEditMode) {
      return;
    }
    const series = event.legendItem;
    const isSeriesVisible = series.visible;

    if (!isSeriesVisible) {
      series.show();
    } else {
      series.hide();
    }
    const rangeSeries = this.getRangeSerieByName(series.name, series.chart.series);
    if (rangeSeries) {
      if (!isSeriesVisible && series.selected) {
        rangeSeries.show();
      } else {
        rangeSeries.hide();
        if (isSeriesVisible) {
          if (series.selected) {
            series.select(false);
          }
          const parentSignalName = rangeSeries.userOptions.signalName.replace('_range', '');
          this.setSignalOrRangeVisibility(machineId, parentSignalName, false, false, undefined);
        }
      }
    }
    const signalName = isLineChart ? series.userOptions.name : series.userOptions.signalName;
    this.setSignalOrRangeVisibility(machineId, signalName, !isSeriesVisible, true, chartId);
  }


  private getRangeSerieByName(name, series) {
    if (!name || name.length === 0) {
      return null;
    }
    if (!series || series.length === 0) {
      return null;
    }

    for (const item of series) {
      if (item.name === name + '_range') {
        return item;
      }
    }
    return null;
  }

  public getSignalVisibility(machineId: string, signalName: string, fallbackValue: boolean = true): boolean {
    const storageKey = 'interactiveDataAnalysis_signalsVisibility_' + machineId;
    const storageEntryValue = this.storageService.readValueFromSessionStorage(storageKey);
    if (!storageEntryValue || storageEntryValue === 'null') {
      return fallbackValue;
    }
    const storageParsedValues = JSON.parse(storageEntryValue);
    const storedVisibility = storageParsedValues?.[signalName]?.isSignalVisible;
    return this.isDefined(storedVisibility) ? storedVisibility : fallbackValue;
  }

  private setSignalOrRangeVisibility(machineId, signalName, isVisible, isSignal, chartId) {
    let signal = signalName;
    if(signal === 'LeftAxis' || signal === 'RightAxis') {
      signal = signal + '_' + chartId;
    }
    const storageKey = 'interactiveDataAnalysis_signalsVisibility_' + machineId;
    const storageEntryValue = this.storageService.readValueFromSessionStorage(storageKey);
    let storageParsedValues;
    if (!storageEntryValue || storageEntryValue === 'null') {
      storageParsedValues = {};
    } else {
      storageParsedValues = JSON.parse(storageEntryValue);
      if (!this.isDefined(storageParsedValues)) {
        storageParsedValues = {};
      }
    }

    if (storageParsedValues[signal] === null || !this.isDefined(storageParsedValues[signal])) {
      storageParsedValues[signal] = {};
    }
    if (isSignal) {
      storageParsedValues[signal].isSignalVisible = isVisible;
    } else {
      storageParsedValues[signal].isRangeVisible = isVisible;
    }
    this.storageService.writeValueToSessionStorage(storageKey, JSON.stringify(storageParsedValues));

  }

  private isDefined(value) {
    return typeof value !== 'undefined';
  }

  private lineWidgetLegendFormatter(legend) {
    if (!legend.linkedSeries || legend.linkedSeries.length === 0) {
      return this.generateSeriesLayout(legend);
    }
    return this.generateAxisLayout(legend);


  }

  private generateSeriesLayout(item) {
    return '<span>' +
        '<i class="fal fa-minus fa-lg" style="color: ' + item.color + '"></i>&nbsp;' +
        '<span>' + item.name + '</span>' +
        '</span>';
  }

  private generateAxisLayout(item) {
    return '<span style="margin-left: 15px;">' +
        '<i style="color: ' + item.color + '"></i>&nbsp;' +
        '<span><strong>' + item.name + '</strong></span>' +
        '</span>';
  }
}
